export default __webpack_public_path__ + "static/gdscLogo-29fb337fb08dff2ed23fa52a3d1dd2fb.svg";